import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerProfileFacade } from './customer-profile.facade';
import { CustomerProfile } from '@models/resources/customer-profile.model';
import { DEMO_CUSTOMER_PROFILE } from '@data/fixtures/customer-profile.fixtures';
import { dummyResponse } from '@data/dummy-response.util';

@Injectable()
export class DummyCustomerProfileFacade implements CustomerProfileFacade {
  getProfile(): Observable<CustomerProfile> {
    return dummyResponse('customer.profile', DEMO_CUSTOMER_PROFILE);
  }
}
